import {
  PAGE_IOR_ASSIGNEES,
  PAGE_IOR_CORRECTIVE_ACTION,
  PAGE_IOR_CORRECTIVE_ACTIONS,
  PAGE_IOR_DASHBOARD,
  PAGE_IOR_EDIT_ASSIGNEE,
  PAGE_IOR_EDIT_INVESTIGATOR,
  PAGE_IOR_EDIT_REPORT,
  PAGE_IOR_INVESTIGATORS,
  PAGE_IOR_MY_REPORTS,
  PAGE_IOR_NEW_ASSIGNEE,
  PAGE_IOR_NEW_INVESTIGATOR,
  PAGE_IOR_NEW_REPORT,
  PAGE_IOR_REPORTS,
  PAGE_IOR_VIEW_REPORT
} from "../../pages/Ior/routes";
import {
  PAGE_QAM_ACTIVITIES,
  PAGE_QAM_ACTIVITIES_CALENDAR,
  PAGE_QAM_ACTIVITY_ACTIONS,
  PAGE_QAM_ACTIVITY_CHECKLIST,
  PAGE_QAM_ACTIVITY_PROGRAM,
  PAGE_QAM_AUDITEES,
  PAGE_QAM_AUDITORS,
  PAGE_QAM_CATALOGUES,
  PAGE_QAM_CORRECTIVE_ACTION,
  PAGE_QAM_CORRECTIVE_ACTIONS,
  PAGE_QAM_DASHBOARD,
  PAGE_QAM_EDIT_AUDITEE,
  PAGE_QAM_EDIT_AUDITOR,
  PAGE_QAM_ENTITIES,
  PAGE_QAM_NEW_AUDITEE,
  PAGE_QAM_NEW_AUDITOR
} from "../../pages/Qam/routes";
import {
  PERMISSION_CREATE_IOR_REPORTS,
  PERMISSION_MANAGE_IOR_REPORTS,
  PERMISSION_VIEW_IOR_ALL_REPORTS,
  PERMISSION_VIEW_IOR_ASSIGNEES,
  PERMISSION_VIEW_IOR_CORRECTIVE_ACTIONS,
  PERMISSION_VIEW_IOR_INVESTIGATORS,
  PERMISSION_VIEW_IOR_REPORTS,
  PERMISSION_VIEW_IOR_ROOT_CAUSES,
  PERMISSION_VIEW_QAM_AUDITEES,
  PERMISSION_VIEW_QAM_AUDITORS,
  PERMISSION_VIEW_QAM_AUDITS,
  PERMISSION_VIEW_QAM_CORRECTIVE_ACTIONS,
  PERMISSION_VIEW_QAM_DASHBOARD,
  PERMISSION_VIEW_QAM_ENTITIES,
  PERMISSION_VIEW_QAM_NORMS,
  PERMISSION_VIEW_QAM_ROOT_CAUSES
} from "./permissions/permissions";

/** Incident/Occurrence Reporting — reports, investigators, assignees, corrective actions. */
export const NAV_IOR = {
  key: "ior",
  name: "container.sidebar.ior",
  iconClassName: "ti-bolt",
  gates: [
    PERMISSION_VIEW_IOR_REPORTS,
    PERMISSION_MANAGE_IOR_REPORTS,
    PERMISSION_CREATE_IOR_REPORTS,
    PERMISSION_VIEW_IOR_ALL_REPORTS,
    PERMISSION_VIEW_IOR_CORRECTIVE_ACTIONS,
    PERMISSION_VIEW_IOR_ROOT_CAUSES
  ],
  submenu: [
    {
      key: "ior.dashboard",
      name: "container.sidebar.dashboard",
      path: PAGE_IOR_DASHBOARD,
      gates: PERMISSION_VIEW_IOR_REPORTS
    },
    {
      key: "ior.ior_reports",
      name: "container.sidebar.ior_reports",
      path: PAGE_IOR_REPORTS,
      gates: [PERMISSION_MANAGE_IOR_REPORTS, PERMISSION_VIEW_IOR_ALL_REPORTS],
      activeRoutes: [PAGE_IOR_VIEW_REPORT, PAGE_IOR_NEW_REPORT, PAGE_IOR_EDIT_REPORT]
    },
    {
      key: "ior.ior_my_reports",
      name: "container.sidebar.ior_my_reports",
      path: PAGE_IOR_MY_REPORTS,
      gates: PERMISSION_CREATE_IOR_REPORTS
    },
    {
      key: "ior.ior_investigators",
      name: "container.sidebar.ior_investigators",
      path: PAGE_IOR_INVESTIGATORS,
      activeRoutes: [PAGE_IOR_NEW_INVESTIGATOR, PAGE_IOR_EDIT_INVESTIGATOR],
      gates: PERMISSION_VIEW_IOR_INVESTIGATORS
    },
    {
      key: "ior.ior_assignees",
      name: "container.sidebar.ior_assignees",
      path: PAGE_IOR_ASSIGNEES,
      activeRoutes: [PAGE_IOR_NEW_ASSIGNEE, PAGE_IOR_EDIT_ASSIGNEE],
      gates: PERMISSION_VIEW_IOR_ASSIGNEES
    },
    {
      key: "ior.corrective_actions",
      name: "container.sidebar.corrective_actions",
      path: PAGE_IOR_CORRECTIVE_ACTIONS,
      activeRoutes: [PAGE_IOR_CORRECTIVE_ACTION],
      gates: PERMISSION_VIEW_IOR_CORRECTIVE_ACTIONS
    }
  ]
};

/** Quality Audit Management — audit activities, entities, auditors/auditees, corrective actions. */
export const NAV_QAM = {
  key: "qam",
  name: "container.sidebar.qam",
  iconClassName: "ti-check-box",
  gates: [
    PERMISSION_VIEW_QAM_DASHBOARD,
    PERMISSION_VIEW_QAM_AUDITS,
    PERMISSION_VIEW_QAM_ENTITIES,
    PERMISSION_VIEW_QAM_AUDITORS,
    PERMISSION_VIEW_QAM_AUDITEES,
    PERMISSION_VIEW_QAM_NORMS,
    PERMISSION_VIEW_QAM_CORRECTIVE_ACTIONS,
    PERMISSION_VIEW_QAM_ROOT_CAUSES
  ],
  submenu: [
    {
      key: "qam.dashboard",
      name: "container.sidebar.dashboard",
      path: PAGE_QAM_DASHBOARD,
      gates: PERMISSION_VIEW_QAM_DASHBOARD
    },
    {
      key: "qam.activities",
      name: "container.sidebar.activities",
      path: PAGE_QAM_ACTIVITIES,
      activeRoutes: [
        PAGE_QAM_ACTIVITIES_CALENDAR,
        PAGE_QAM_ACTIVITY_ACTIONS,
        PAGE_QAM_ACTIVITY_CHECKLIST,
        PAGE_QAM_ACTIVITY_PROGRAM
      ],
      gates: PERMISSION_VIEW_QAM_AUDITS
    },
    {
      key: "qam.entities",
      name: "container.sidebar.entities",
      path: PAGE_QAM_ENTITIES,
      gates: PERMISSION_VIEW_QAM_ENTITIES
    },
    {
      key: "qam.auditors",
      name: "container.sidebar.auditors",
      path: PAGE_QAM_AUDITORS,
      activeRoutes: [PAGE_QAM_EDIT_AUDITOR, PAGE_QAM_NEW_AUDITOR],
      gates: PERMISSION_VIEW_QAM_AUDITORS
    },
    {
      key: "qam.auditees",
      name: "container.sidebar.auditees",
      path: PAGE_QAM_AUDITEES,
      activeRoutes: [PAGE_QAM_EDIT_AUDITEE, PAGE_QAM_NEW_AUDITEE],
      gates: PERMISSION_VIEW_QAM_AUDITEES
    },
    {
      key: "qam.catalogues",
      name: "container.sidebar.catalogues",
      path: PAGE_QAM_CATALOGUES,
      gates: PERMISSION_VIEW_QAM_NORMS
    },
    {
      key: "qam.corrective_actions",
      name: "container.sidebar.corrective_actions",
      path: PAGE_QAM_CORRECTIVE_ACTIONS,
      activeRoutes: [PAGE_QAM_CORRECTIVE_ACTION],
      gates: PERMISSION_VIEW_QAM_CORRECTIVE_ACTIONS
    }
  ]
};
